import { render } from "./packageManagementXuser.vue?vue&type=template&id=5a7778f5&scoped=true"
import script from "./packageManagementXuser.vue?vue&type=script&lang=js"
export * from "./packageManagementXuser.vue?vue&type=script&lang=js"

import "./packageManagementXuser.vue?vue&type=style&index=0&id=5a7778f5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a7778f5"

export default script